<template>
  <ai-carousel-with-description
    id="HotelSportsOverview"
    v-model="currentStep"
    access-id="HotelSportsOverviewCarousel"
    background="neutral"
    :items="items"
    :title="$t('hotel.sportsOverview.title')"
    :description="description"
    mobile-button
    :gutter="gutter"
    :slide-width="slideWidth"
    :aria-label="$t('hotel.sportsOverview.title')"
    inverse
    gallery-on-carousel-click />
</template>

<script setup lang="ts">
interface HotelSportsOverviewProps {
  images: AiImageProps[];
  description: string;
}

const props = defineProps<HotelSportsOverviewProps>();
const items = props.images.map(image => ({ ...image, loading: 'lazy' }));

const isSmallDevice = useMatchMediaQuery('tablet');
const isDesktopDevice = useMatchMediaQuery('large-desktop');

const gutter = computed(() => {
  if (isSmallDevice.value) return 16;

  return isDesktopDevice.value ? 64 : 32;
});
const slideWidth = computed(() => (isSmallDevice.value ? 0.9 : 1));

const currentStep = ref<number>(1);
</script>
